module.exports = flarum.core.compat['common/models/WikiLabelOptions'];